export default {"src":"/_next/static/media/maths.fc3798c4.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};